import {
    DepartmentAction,
    DepartmentActionType,
} from '../actions/DepartmentActions';
import { Department } from '../types';

const departmentReducer = (
    state: Array<Department> = [],
    action: DepartmentAction
) => {
    switch (action.type) {
        case DepartmentActionType.GET_ALL_DEPARTMENTS:
            return action.payload;
        case DepartmentActionType.CREATE_DEPARTMENT:
            return [...state, action.payload];
        case DepartmentActionType.GET_DEPARTMENT:
        case DepartmentActionType.DELETE_DEPARTMENTS:
        case DepartmentActionType.MERGE_DEPARTMENTS:
        case DepartmentActionType.UPDATE_DEPARTMENT:
            return state.map((department: Department) => {
                const newDepartment = action.payload as Department;
                if (department._id === newDepartment._id) {
                    return newDepartment;
                } else {
                    return department;
                }
            });
        default:
            return state;
    }
};

export default departmentReducer;
